import {
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_IMPORTED,
  USER_STATUS_CODE_INVITED,
  USER_STATUS_CODE_NOT_CONFIRMED,
} from '../../../../constants/user'

const FULL_PERMISSIONS = {
  can_block_user: true,
  can_create_request: true,
  can_delete: true,
  can_edit_files: true,
  can_manage_all_user_flats: true,
  can_restore: true,
  can_send_invite: true,
  can_unblock_user: true,
  can_view_files: true,
}

const BASE_INHABITANT_MOCK = {
  directory_id: 'mock-directory-id',
  id: 9999999,
  isArchived: false,
  permissions: FULL_PERMISSIONS,
}

export const PROFILE_ACTIONS_WIDGET_INHABITANT_VARIANTS = [
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Jonas Weber',
      status: USER_STATUS_CODE_INVITED,
    },
    label: 'Actions widget, status — Invited',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Maximilian von Habsburg',
      status: USER_STATUS_CODE_ACTIVE,
    },
    label: 'Actions widget, status — Online (active)',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Anna Schmidt',
      status: USER_STATUS_CODE_IMPORTED,
    },
    label: 'Actions widget, status — Imported',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Lukas Müller',
      status: USER_STATUS_CODE_BLOCKED,
    },
    label: 'Actions widget, status — Blocked',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Sophie Becker',
      status: USER_STATUS_CODE_NOT_CONFIRMED,
    },
    label: 'Actions widget, status — Invalid (not confirmed)',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Elena Fischer',
      isArchived: true,
      status: USER_STATUS_CODE_ACTIVE,
    },
    label: 'Actions widget, archived',
  },
  {
    inhabitantData: {
      ...BASE_INHABITANT_MOCK,
      fullname: 'Daniel Hoffmann',
      permissions: {},
      status: USER_STATUS_CODE_ACTIVE,
    },
    label: 'Actions widget, dweller viewer — no permissions (no icon bar)',
  },
]
